import * as React from "react";
import * as cn from "classnames/bind";
import { loginUser, addUser } from "page/user/service";
import Button from "content/button/button";
import { UserRole } from "user/constants";
import * as styles from "./login-box.css";
import { getResource } from "resource/store";
import { COOKIE_USER_EXPIRE_DAYS, COOKIE_USER_JWT } from "ui/constants";
import { createUser } from "burde-api-content/burde-user-service";
import Cookies from "js-cookie";

const cx = cn.bind(styles);

const inputBoxCn = (hasErrors: boolean) =>
    cx({
        input: true,
        inputWithError: hasErrors,
    });

const labelCn = () =>
    cx({
        label: true,
    });

const errorLabelCn = () =>
    cx({
        label: true,
        errorLabel: true,
    });

interface RegisterProps {
    getResource: (key: string) => string;
    login: (user: any) => any;
    swapToLoginClick: () => any;
    onSuccessfulRegister: () => any;
    domain: string;
}

interface RegisterState {
    userName: string;
    password: string;
    passwordConfirmation: string;
    formErrorText: string | null;
}

class RegisterForm extends React.Component<RegisterProps, RegisterState> {
    public state: RegisterState = {
        userName: "",
        password: "",
        passwordConfirmation: "",
        formErrorText: null,
    };

    private isFormValid = () => {
        const { userName, password, passwordConfirmation } = this.state;
        const { getResource } = this.props;

        let error = null;
        const mailRx = /\S+@\S+\.\S+/;

        if (!userName || userName === "") {
            error = getResource("Register_Error_MissingEmail");
        } else if (!mailRx.test(userName)) {
            error = getResource("Register_Error_WrongEmail");
        }

        if (!password || password === "") {
            error = getResource("Register_Error_MissingPassword");
        }

        if (password !== passwordConfirmation) {
            error = getResource("Register_Error_MismatchPassword");
        }

        this.setState({
            formErrorText: error,
        });

        if (error) {
            return false;
        }

        return true;
    };

    private register = async () => {
        if (!this.isFormValid()) {
            return;
        }

        const { userName, password, passwordConfirmation } = this.state;

        if (
            !userName ||
            userName === "" ||
            !password ||
            password === "" ||
            password !== passwordConfirmation
        ) {
        } else {
            const { success, data } = await createUser(userName, password);

            if (success) {
                Cookies.set(COOKIE_USER_JWT, data.jwt, {
                    expires: COOKIE_USER_EXPIRE_DAYS,
                    domain: this.props.domain,
                });

                this.props.onSuccessfulRegister();
                this.setState({ password: "", passwordConfirmation: "" });
            } else {
                // Generic API error for now.
                this.setState({
                    formErrorText: data.message,
                });
            }
        }
    };

    private swapToLoginClicked = () => {
        this.props.swapToLoginClick();
    };

    private loginOnEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.keyCode === 13) {
            // enter key pressed
            e.preventDefault();
            e.stopPropagation();

            this.register();
        }
    };

    private registerClicked = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        e.stopPropagation();

        this.register();
    };

    private changeUserName = (e: React.ChangeEvent<HTMLInputElement>) =>
        this.setState({
            userName: e.target.value,
        });

    private changePassword = (e: React.ChangeEvent<HTMLInputElement>) =>
        this.setState({
            password: e.target.value,
        });

    private changeConfirmPassword = (e: React.ChangeEvent<HTMLInputElement>) =>
        this.setState({
            passwordConfirmation: e.target.value,
        });

    public render() {
        const {
            password,
            userName,
            passwordConfirmation,
            formErrorText,
        } = this.state;

        const { getResource } = this.props;

        return (
            <form>
                <h3>{getResource("Register_Text_Header")}</h3>
                <p>
                    {getResource("Register_Text_Lead")}
                    <strong> {getResource("Register_Text_Lead_Bold")}</strong>
                </p>
                <label className={labelCn()}>
                    {getResource("Register_Form_Email")}
                </label>
                <input
                    className={inputBoxCn(false)}
                    type="email"
                    required={true}
                    value={userName}
                    onKeyUp={this.loginOnEnter}
                    onChange={this.changeUserName}
                />
                <label className={labelCn()}>
                    {getResource("Register_Form_Password")}
                </label>
                <input
                    className={inputBoxCn(false)}
                    id={"password"}
                    type={"password"}
                    required={true}
                    value={password}
                    onKeyUp={this.loginOnEnter}
                    onChange={this.changePassword}
                />
                <label className={labelCn()}>
                    {getResource("Register_Form_ConfirmPassword")}
                </label>
                <input
                    className={inputBoxCn(false)}
                    id={"confirm_password"}
                    type={"password"}
                    required={true}
                    value={passwordConfirmation}
                    onKeyUp={this.loginOnEnter}
                    onChange={this.changeConfirmPassword}
                />
                <label
                    className={errorLabelCn()}
                    style={{ textAlign: "center" }}>
                    {formErrorText}
                </label>
                <Button
                    text={getResource("Register_Button_Register")}
                    width={"100%"}
                    onClick={this.registerClicked}
                />
                <div>
                    <br />
                    {getResource("Register_ExistingAccount")}{" "}
                    <strong>
                        <a
                            style={{ cursor: "pointer" }}
                            onClick={this.swapToLoginClicked}>
                            {" "}
                            {getResource("Register_Login_Link")}
                        </a>
                    </strong>
                </div>
            </form>
        );
    }
}

export default RegisterForm;
